import { ActionTypes } from '../actions';

const initialState = {
  all_elections: [],
  elections: {},
  approved_elections: [],
  unapproved_elections: [],
  selectedElection: undefined,
};

const ElectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_ELECTIONS:
      return {
        ...state,
        elections: action.payload.reduce((acc, curr) => ({
          ...acc,
          [curr._id]: curr,
        }), {}),
      };

    case ActionTypes.SET_ALL_ELECTIONS:
      return {
        ...state,
        all_elections: action.payload,
      };

    case ActionTypes.SET_ALL_APPROVED_ELECTIONS:
      return {
        ...state,
        approved_elections: action.payload,
      };

    case ActionTypes.SET_ALL_UNAPPROVED_ELECTIONS:
      return {
        ...state,
        unapproved_elections: action.payload,
      };

    case ActionTypes.SET_SELECTED_ELECTION:
      return {
        ...state,
        selectedElection: state.all_elections.find(e => e._id === action.payload),
      };

    case ActionTypes.SET_SELECTED_ELECTION_OBJ:
      return {
        ...state,
        selectedElection: action.payload,
      };

    case ActionTypes.CLEAR_ELECTIONS:
      return { ...state, elections: initialState.elections };

    case ActionTypes.CLEAR_SELECTED_ELECTION:
      return { ...state, selectedElection: initialState.selectedElection };

    default:
      return state;
  }
};

export default ElectionReducer;
